import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "33",
  height: "33",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4 19a1 1 0 0 1 1 1c0 1.914.002 3.249.138 4.256.131.978.372 1.496.74 1.865.37.37.888.61 1.866.742C8.751 26.998 10.086 27 12 27h8c1.914 0 3.249-.002 4.256-.137.978-.132 1.496-.373 1.865-.742.37-.369.61-.887.742-1.865.135-1.007.137-2.342.137-4.256a1 1 0 1 1 2 0v.073c0 1.824 0 3.293-.155 4.45-.162 1.2-.507 2.21-1.31 3.012-.802.803-1.812 1.148-3.013 1.31-1.156.155-2.625.155-4.449.155h-8.146c-1.824 0-3.293 0-4.45-.155-1.2-.162-2.21-.507-3.013-1.31-.802-.802-1.147-1.812-1.309-3.013C3 23.366 3 21.897 3 20.073V20a1 1 0 0 1 1-1",
      "clip-rule": "evenodd",
      opacity: ".5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15.997 3a1 1 0 0 1 .738.325L22.07 9.16a1 1 0 0 1-1.476 1.35l-3.596-3.933v14.757a1 1 0 1 1-2 0V6.576l-3.595 3.932a1 1 0 0 1-1.476-1.35l5.333-5.833A1 1 0 0 1 15.997 3",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }